import React from "react";

const CreditNotesPage = () => {
  return <div></div>;
};

export default CreditNotesPage;
